module.exports = __webpack_public_path__ + "img/psychai_logo.ee0d087b.png";